import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Modal } from '@/components';
import ROUTES from '@/router/routes';
import { SelectedScreen } from '@/types/editProfile';

type TypeState = {
  visibility: boolean;
  title: string;
  returnPage?: keyof typeof ROUTES;
};

export const useCbuModal = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<TypeState>({
    visibility: false,
    title: '',
    returnPage: undefined,
  });

  const paymentDetailsContent = useCallback(() => {
    return (
      <div className="flex flex-col items-center content-center mt-4">
        <h1 className="font-bold uppercase text-center">
          Necesitamos nos compartas cierta información
        </h1>
        <p className="text-center font-semibold mt-2">
          Por favor completá{' '}
          <span
            className="text-blue-500 underline cursor-pointer"
            onClick={() =>
              navigate(ROUTES.editAccount.myCBU, {
                state: {
                  ...(modal.returnPage && {
                    returnPage:
                      modal.returnPage || ROUTES.friendsTournamentPrizes,
                  }),
                } as SelectedScreen,
              })
            }
          >
            acá
          </span>{' '}
          estos datos para que puedas recibir tu premio si sos el campeón.
        </p>
      </div>
    );
  }, [modal.returnPage, navigate]);

  const ModalCBU = useCallback(() => {
    return (
      <Modal
        controlledOnClose={() => {
          setModal({ visibility: false, title: '' });
        }}
        disableBodyScroll={true}
        isControlledOpen={modal.visibility}
        render={paymentDetailsContent}
        size="xs"
        title={modal?.title || ''}
        variant="controlled"
      />
    );
  }, [modal?.title, modal.visibility, paymentDetailsContent]);

  return {
    ModalCBU,
    setModalCBU: setModal,
  };
};
